import React from 'react';

const OpportunityDetail = React.lazy(
  () => import('@/pages/InvestmentProjects/Detail'),
);
const OrderDetail = React.lazy(() => import('@/pages/InvestmentOrders/Detail'));
const OrderEditor = React.lazy(() => import('@/pages/InvestmentOrders/Editor'));
const ContractDetail = React.lazy(() => import('@/pages/Contracts/Detail'));
const ContractEditor = React.lazy(() => import('@/pages/Contracts/Editor'));
const ContractRenewal = React.lazy(() => import('@/pages/Contracts/Renewal'));
const ContractSupplement = React.lazy(
  () => import('@/pages/Contracts/Supplement'),
);
const ContractGeneration = React.lazy(
  () => import('@/pages/Contracts/GenerationPage'),
);
const ContractHistory = React.lazy(
  () => import('@/pages/Contracts/HistoryPage'),
);
const LeadDetail = React.lazy(() => import('@/pages/CrmLead/Detail'));
const CustomerDetail = React.lazy(() => import('@/pages/CrmCustomer/Detail'));

export default function detailComponent(path: string) {
  const pathname = path.split('?')[0];
  if (/^\/attraction\/opportunity\/[^/]+$/.test(pathname))
    return OpportunityDetail;
  if (/^\/attraction\/order\/[^/]+\/edit$/.test(pathname)) return OrderEditor;
  if (/^\/attraction\/order\/[^/]+$/.test(pathname)) return OrderDetail;
  if (/^\/attraction\/lead\/[^/]+$/.test(pathname)) return LeadDetail;
  if (/^\/attraction\/customer\/[^/]+$/.test(pathname)) return CustomerDetail;
  if (/^\/contract\/(new|[^/]+\/edit)$/.test(pathname)) return ContractEditor;
  if (
    /^\/contract\/[^/]+\/supplement\/new$/.test(pathname) ||
    /^\/contract\/supplement\/[^/]+$/.test(pathname)
  )
    return ContractSupplement;
  if (/^\/contract\/[^/]+\/renew$/.test(pathname)) return ContractRenewal;
  if (/^\/contract\/[^/]+\/generate$/.test(pathname)) return ContractGeneration;
  if (/^\/contract\/[^/]+\/history\/\d+$/.test(pathname))
    return ContractHistory;
  if (/^\/contract\/[^/]+$/.test(pathname)) return ContractDetail;
  return undefined;
}
